import React, { Component, Fragment } from 'react';
import I18n from '~/utils/translations';

export default class ConfirmButton extends Component {
  render() {
    return (
      <Fragment>
        {this.props.title && <h3 className="book-a-viewing__step-title">{this.props.title}</h3>}
        <button
          type="submit"
          id="confirm-button"
          className={`viewing-confirm-button button primary ${this.props.loading ? 'loading' : ''}`}
          data-ga-category="home-viewing-flow"
          data-ga-action={this.props.viewingEvent ? 'submit-viewing-event' : 'submit-viewing'}
          disabled={this.props.disabled || this.props.loading}
          onClick={this.props.onClick}
        >
          {this.viewingButtonText}
        </button>
      </Fragment>
    );
  }

  get viewingButtonText() {
    if (this.props.viewingEvent) {
      return I18n.t('viewings.book_event_confirm_btn');
    }

    return this.props.property.requestViewingEnabled
      ? I18n.t('viewings.request_confirm_btn')
      : I18n.t('viewings.book_confirm_btn');
  }
}
